import { useGlobal } from '@/utils/useGlobal';
import { Tabs } from 'antd';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import EFVideo from '@/components/UI/EFVideo';

export default function SwitchTabN() {
    const { useLang, isMobile, useEffect, useRouter } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const { locale } = useRouter();
    const tabs = [
        {
            videoUrl: [`/video/dg200/10_1${isMobile ? '_h5' : ''}.webm`, `/video/dg200/10_1${isMobile ? '_h5' : ''}.mp4`],
            tab: t('dg200.videoCells_video1'),
            showVideo: true,
            subTab: '',
            key: 1,
        },
        {
            videoUrl: [`/video/dg200/10_2${isMobile ? '_h5' : ''}.webm`, `/video/dg200/10_2${isMobile ? '_h5' : ''}.mp4`],
            tab: t('dg200.videoCells_video2'),
            showVideo: true,
            subTab: '',
            key: 2,
        },
        {
            videoUrl: [
                `/video/dg200/10_3${isMobile ? '_h5' : ''}${locale === 'cn' ? '_' + locale : ''}.webm`,
                `/video/dg200/10_3${isMobile ? '_h5' : ''}${locale === 'cn' ? '_' + locale : ''}.mp4`,
            ],
            tab: t('dg200.videoCells_video3'),
            showVideo: true,
            subTab: '',
            key: 3,
        },
        {
            videoUrl: [`/video/dg200/10_4${isMobile ? '_h5' : ''}.webm`, `/video/dg200/10_4${isMobile ? '_h5' : ''}.mp4`],
            tab: t('dg200.videoCells_video4'),
            showVideo: true,
            subTab: '',
            key: 4,
        },
    ];

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const textFadeInOut = (el: any) => {
        const target = `.dg200 .switchTabN ${el}`;
        const targetEl = document.querySelector(target) as HTMLElement;
        const targetH = targetEl?.offsetHeight || 100;

        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: targetH,
        });
        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        scene1.setTween(tween1);
        scene1.addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: targetH,
            triggerHook: 1,
            duration: targetH,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(controller);

        const scene3 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: isMobile ? '-.44rem' : '-60px',
            triggerHook: 0,
            duration: targetH,
        });
        const tween3 = TweenMax.fromTo(target, 0.5, { opacity: 1 }, { opacity: 0 });
        scene3.setTween(tween3);
        scene3.addTo(controller);
    };

    useEffect(() => {
        if (!isMobile) {
            textFadeInOut('.textBox .title');
            textFadeInOut('.textBox .desc');
            textFadeInOut('.textBox .sup');
            textFadeInOut('.tabsBox .ant-tabs-nav');
        }
    }, []);

    return (
        <div className={`switchTabN ${css.switchTabN} ${isMobile ? 'switchTabN_h5' : 'switchTabN_pc'}`}>
            <div className="textBox">
                <p className="title">{t('dg200.videoCells_title')}</p>
                <p className="desc">{t('dg200.videoCells_desc')}</p>
                <p className="sup">{t('dg200.videoCells_sup')}</p>
            </div>
            <div className="tabsBox">
                <Tabs>
                    {tabs?.map((tab: any, k: number) => (
                        <Tabs.TabPane key={k} tab={tab.tab}>
                            <div className="tabImg">
                                <EFVideo className="switchTabN-video" sources={tab.videoUrl} width="100%" height="100%" ari-label={tab.tab} />
                            </div>
                        </Tabs.TabPane>
                    ))}
                </Tabs>
            </div>
        </div>
    );
}
